import React from "react";
import { FaGithub, FaGlobe } from "react-icons/fa";

const ProjectCard = ({
  header,
  duration,
  srcImage,
  orderFirst,
  description,
  visitLink,
  codeLink,
}) => {
  const handleClick = () => {
    if (window.innerWidth < 768 && visitLink) {
      window.open(visitLink, "_blank");
    }
  };

  return (
    <div
      className="grid lg:grid-cols-2 justify-center items-center w-full my-8 pb-2 pl-4 pr-4 lg:pl-8 lg:pr-8 lg:pb-0 bg-white rounded-xl shadow-custom cursor-pointer lg:cursor-default"
      onClick={handleClick}
    >
      <img
        src={srcImage}
        alt="Project infographic"
        className={`overflow-hidden scale-120 relative z-10 ${
          orderFirst ? "lg:order-first" : "lg:order-last lg:translate-x-8"
        }`}
      />
      <div className={`${orderFirst ? "lg:text-left" : "lg:text-right"}`}>
        <h2 className="text-lg mdl:text-xl text-designColor font-titleFont font-semibold mb-1 mdl:mb-3">
          {header}
        </h2>
        <h2 className="text-xs md:text-sm mb-2 text-black">{duration}</h2>
        <p className="text-xs mdl:text-sm text-black font-bodyFont">
          {description}
        </p>
        <div
          className={`flex flex-col xs:flex-row gap-x-4 gap-y-3 mt-4 ${
            orderFirst ? "lg:justify-start" : "lg:justify-end"
          }`}
        >
          <div className="pb-2">
            <p className="font-semibold text-designColor">Explore more:</p>
            <div
              className={`flex space-x-4 mt-4 ${
                orderFirst ? "lg:justify-start" : "lg:justify-end"
              }`}
            >
              {codeLink && (
                <a
                  href={codeLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="exploreIcon z-20"
                  onClick={(e) => e.stopPropagation()} // prevent opening visitLink on mobile
                >
                  <FaGithub />
                </a>
              )}
              {visitLink && (
                <a
                  href={visitLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="exploreIcon z-20"
                  onClick={(e) => e.stopPropagation()} // prevent double-trigger
                >
                  <FaGlobe />
                </a>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProjectCard;
